/**
 * APIUrls file for CRM waiting period related api endpoints.
 */

export const BASE_API_URL = '/api/data/v9.1';

export const URLS = {
  GET_MEMBERSHIP_MEMBERS: `${BASE_API_URL}/dhl_membershipmemberses`,
  GET_MEMBERSHIP_POLICIES: `${BASE_API_URL}/dhl_membershippolicies`,
  GET_PREMIUM_ADJUSTMENTS: `${BASE_API_URL}/dhl_PremiumAdjustments`,
  GET_INTERNAL_CONFIGURATIONS: `${BASE_API_URL}/dhl_configurations`,
  GET_BAMBORA_TOKEN: `${BASE_API_URL}/dhl_GetCreditCardTokenFromBambora`,
  SAVE_REBATE_FORM: `${BASE_API_URL}/dhl_SaveRebateForm`,
  LHC_OVERRULE_REFERENCE_VALUES: `${BASE_API_URL}/dhl_lhcreasons`,
  CREATE_WORK_ITEM: `${BASE_API_URL}/dhl_Createworkitem`,
  SOLICITED_PAYMENT: `${BASE_API_URL}/dhl_SolicitedPayment`,
};

export const CONFIG = {
  headers: {
    'OData-MaxVersion': '4.0',
    'OData-Version': '4.0',
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    Prefer: 'odata.include-annotations="*"',
  },
};
